import React from "react";
import MessagesList from "./MessagesList";
import MessageForm from "./MessageForm";
import MeetingDetails from "./MeetingDetails";

function Chat() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <MeetingDetails />
      <div
        className="relative h-full pb-1"
        style={{ height: "60vh", maxHeight: "80vh" }}
      >
        <MessagesList />
        <MessageForm />
      </div>
    </div>
  );
}

export default Chat;
